import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { ReactComponent as ICS } from "../../../../../Assets/icon/ics-file-format.svg";
import { ReactComponent as CloseIcon } from "../../../../../Assets/icon/close.svg";
import { useState } from "react";

const AddToCalendar = ({ onClose, hideCloseIcon = false, setPage, selectedSession }) => {
  const [showForm, setShowForm] = useState(null);

  return (
    <div className='add-session-container'>
      <div className='add-session-header'>
        <p>Add your session to your calendar</p>
        {!hideCloseIcon && <CloseIcon style={{ cursor: 'pointer' }} onClick={onClose} />}
      </div>
      {showForm === null && (
        <div className="buttons-container">
          <div className="schedule-button">
            <FcGoogle size={24} />
            Google
          </div>
          <div className="schedule-button">
            <FaApple size={24} />
            Apple
          </div>
          <div className="schedule-button">
            <ICS size={24} />
            ICS File
          </div>
        </div>
      )}

      {showForm === 'google' && (
        <form className="calendar-form">
          <h4>Google Calendar Details</h4>
          <input type="text" placeholder="Google Account Email" required />
          <input type="text" placeholder="Event Title" required />
          <div style={{ marginTop: 12 }}>
            <button type="submit">Add to Google Calendar</button>
            <button type="button" onClick={() => setShowForm(null)} style={{ marginLeft: 8 }}>
              Back
            </button>
          </div>
        </form>
      )}

      {showForm === 'apple' && (
        <form className="calendar-form">
          <h4>Apple Calendar Details</h4>
          <input type="text" placeholder="Apple ID Email" required />
          <input type="text" placeholder="Event Title" required />
          <div style={{ marginTop: 12 }}>
            <button type="submit">Add to Apple Calendar</button>
            <button type="button" onClick={() => setShowForm(null)} style={{ marginLeft: 8 }}>
              Back
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddToCalendar;